import {defineMessages} from 'react-intl';

const messages = defineMessages({
  addDetails: {
    id: 'addDetails',
    defaultMessage: 'Add details'
  },
  detailsAdded: {
    id: 'detailsAdded',
    defaultMessage: 'Details added'
  }
});

export default messages;
